import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredOrderDeleteAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderDelete',
  (params: { id: string }) => ({
    tradeBrokeredOrderDelete: {
      __args: {
        id: params.id,
      },
      success: true,
    },
  }),
);
